import React, { useEffect, useState } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { NavLink, useHistory } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Homebar from './Homebar'; 
import Homes from './Homes';
import CountUp from 'react-countup';
import { motion } from "framer-motion";
import ChartDataLabels from 'chartjs-plugin-datalabels'; 
import { Card, Row, Col, Table, Spinner, Form, Button, Modal } from "react-bootstrap";
import axios from "axios";


import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PublicationBarChart from './PublicationBarChart';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Home = () => {
    const [counts, setCounts] = useState({
        userCount: 0,
        mouCount: 0,
        publicationCount: 0,
        researchLabCount: 0,
        projectCount: 0,
        patentCount: 0,
        departmentCount: 0,
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState(''); // State for the search input
    const [email, setEmail] = useState(''); // State  for the email ID
    const [access_level, setAccessLevel] = useState(''); // State for the access level
    const [username, setUsername] = useState(''); // State for the username
    const [designation, setDesignation] = useState(''); // State for the designation
    const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
    const [photo, setPhoto] = useState('');
    const [userId,setUser_id] = useState('');
    const history = useHistory(); // To handle navigation
    const [active,setActive] = useState("");
    const [totalCount, setTotalCount] = React.useState(0);  // Initialize total count
    const [showDemoModal, setShowDemoModal] = useState(false); // State for demo video modal


    const endpoints = [
        { key: 'mous', setter: 'mouCount', icon: 'fas fa-handshake', url: '/MouTable', label: "MOU's" },
        { key: 'publications/publications', setter: 'publicationCount', icon: 'fa-book', url: '/publicationsTable', label: 'Publications' },
        { key: 'projects', setter: 'projectCount', icon: 'fa-tasks', url: '/projectsTable', label: 'Projects' },
        { key: 'patents', setter: 'patentCount', icon: 'fa-gavel', url: '/patentTable', label: 'Patents' },
        { key: 'researchLabs', setter: 'researchLabCount', icon: 'fa-rocket', url: '/reserchTable', label: 'Research Labs' },
        { key: 'departments', setter: 'departmentCount', icon: 'fa-clipboard-list', url: '/departmentsTable', label: 'Departments' },
    ];
    
   var proj=0;
    useEffect(() => {
      
fetchTotalProjectCount()
.then(totalCount => console.log("Total Project Count:1", totalCount))
.catch(error => console.error(error.message));

        // Fetch counts and email
       const fetchCounts = async () => {
    try {
        const newCounts = {};
        let totalCount = 0;  // Variable to store total count

        await Promise.all(
            endpoints.map(async ({ key, setter }) => {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/${key}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch ${key}: ${response.statusText}`);
                }
                const result = await response.json();

                let count = 0;

                // Check if the result contains the 'page' object
                if (result.page) {
                    count = result.page.totalElements;  // Use totalElements from the page object
                } else if (result._embedded) {
                    const embeddedKey = Object.keys(result._embedded)[0];
                    count = result._embedded[embeddedKey].length;
                } else {
                    count = result.length;
                }

                newCounts[setter] = count;  // Assign count to corresponding setter
                totalCount += count;  // Add to total count
            })
        );
       

        newCounts['total'] = totalCount;  // Store the total count
        setCounts(newCounts);  


    } catch (err) {
        setError(err.message);  // Handle any error
    } finally {
        setLoading(false);  // Stop loading
    }
};

fetchCounts();

    
        // Retrieve the email from session storage
        const userEmail = sessionStorage.getItem("userEmail");
        const userAccessLevel = sessionStorage.getItem("accessLevel");
        const username = sessionStorage.getItem("username");
        const designation = sessionStorage.getItem("designation");
        const photo = sessionStorage.getItem("photo");
        const userId = sessionStorage.getItem("userId");
        const active = sessionStorage.getItem("active");
    
        if (userEmail) {
            setEmail(userEmail);
            setAccessLevel(userAccessLevel);
            setUsername(username);
            setDesignation(designation);
            setPhoto(photo);
            setUser_id(userId);
            setActive(active);
        } else {
            history.push("/login"); // Redirect to login if email is not found
        }
    }, [history]); // Removed `counts` from the dependency array
    
    

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

     
    let timeout;
    const accessLevel = parseInt(sessionStorage.getItem("access_level"), 10);

let logoutTriggered = false; 

function resetTimeout() {
  // Clear the previous timeout
  clearTimeout(timeout);

  // Set a new timeout for 15 minutes (900,000 milliseconds)
  timeout = setTimeout(handleLogout, 900000); // 15 minutes
  console.log(timeout);
}

function handleLogout() {
  if (logoutTriggered) return; 

  logoutTriggered = true; 

  // Show the toast message before logout
  toast.success("You have been logged out due to inactivity!");


  setTimeout(() => {
    // Clear session storage
    sessionStorage.removeItem("userEmail");
    sessionStorage.clear();

    window.location.href="/login";
  }, 1000);
}

const logout = () => {
    toast.success("Logged out successfully!");
  
    setTimeout(() => {
      // Clear session storage
      sessionStorage.removeItem("userEmail");
      sessionStorage.clear();
  
      window.location.href="/login";
    }, 1000);
  };

// Event listeners to track user activity and reset timeout
window.addEventListener("mousemove", resetTimeout);
window.addEventListener("keydown", resetTimeout);
window.addEventListener("click", resetTimeout);

// Initialize timeout check when the page loads
window.onload = resetTimeout;

    


const chartData = {
    labels: endpoints.filter(({ key }) => key !== 'users' && key !== 'departments' && key !== 'researchLabs')
        .map(({ key }) => key.charAt(0).toUpperCase() + key.slice(1)),
    datasets: [
        {
            label: "Counts",
            data: endpoints.filter(({ key }) => key !== 'users' && key !== 'departments' && key !== 'researchLabs') // Excluding 'users' and 'department' keys
                .map(({ setter }) => counts[setter] || 0),
                backgroundColor: [
                    '#4B3832', // Rich chocolate brown
                    '#2A4D69', // Deep navy blue
                    '#588157', // Forest green
                    '#8A3335', // Dark red
                    '#2C2D2E', // Charcoal gray
                    '#3A5A40', // Moss green
                    '#5D5F71', // Slate blue
                    '#6A0572', // Dark violet
                    '#5E3023', // Mahogany
                    '#0B6E4F'  // Deep teal
                ],
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 0,
            barThickness: 28,
        },
    ],
};

const pieData = {
    labels: endpoints.filter(({ key }) => key !== 'users' && key !== 'departments' && key !== 'researchLabs') // Excluding 'users' and 'department' keys
        .map(({ key }) => key.charAt(0).toUpperCase() + key.slice(1)),
    datasets: [
        {
            data: endpoints.filter(({ key }) => key !== 'users' && key !== 'departments' && key !== 'researchLabs') // Excluding 'users' and 'department' keys
                .map(({ setter }) => counts[setter] || 0),
                backgroundColor: [
                    '#4B3832', // Rich chocolate brown
                    '#2A4D69', // Deep navy blue
                    '#588157', // Forest green
                    '#8A3335', // Dark red
                    '#2C2D2E', // Charcoal gray
                    '#3A5A40', // Moss green
                    '#5D5F71', // Slate blue
                    '#6A0572', // Dark violet
                    '#5E3023', // Mahogany
                    '#0B6E4F'  // Deep teal
                ],
        },
    ],
};




const piechartOptions = {
    responsive: true,
    plugins: {
        legend: {
            position: 'left',
            labels: {
                font: {
                    size: 16,
                    weight: 'bold',
                },
            },
        },
        tooltip: {
            enabled: true,
        },
    },
    onClick: (event, elements) => {
        if (elements.length > 0) {
            const index = elements[0].index;
            const selectedEndpoint = endpoints
                .filter(({ key }) => key !== 'users' && key !== 'departments' && key !== 'researchLabs') // Exclude 'users' and 'departments'
                [index];
            if (selectedEndpoint) {
                window.location.href = selectedEndpoint.url;
            }
        }
    },
    
};
const fetchTotalProjectCount = async () => {
  try {
      // Step 1: Fetch all departments
      const departmentResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.como.trycloudflare.com'}/api/departments`);
      const validDepartments = departmentResponse.data.filter(dept => dept && dept.deptId);

      // Step 2: Fetch project counts for each department
      const responses = await Promise.all(
          validDepartments.map(dept =>
              axios.get(`${process.env.REACT_APP_API_BASE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.como.trycloudflare.com'}/api/project-departments/project-type-count/${dept.deptId}`)
          )
      );

      // Step 3: Calculate total project count by summing all values for each department
      let totalCount = 0;
      responses.forEach((response, index) => {
          console.log(`Response for ${validDepartments[index].deptName}:`, response.data);

          // Sum all counts in the response object
          const departmentCounts = response.data;
          for (const key in departmentCounts) {
              if (departmentCounts.hasOwnProperty(key)) {
                  const count = departmentCounts[key];
                  totalCount += typeof count === 'number' ? count : 0;  // Add only if the value is a number
              }
          }
      });
      setTotalCount(totalCount); 
      console.log("Total Project Count:", totalCount);
      return totalCount;  // Return the total project count
  } catch (error) {
      console.error("Failed to fetch total project count:", error);
      throw new Error("Failed to fetch total project count.");
  }
};

fetchTotalProjectCount()
.then(totalCount => console.log("Total Project Count:1", totalCount))
.catch(error => console.error(error.message));





    const filteredEndpoints = endpoints.filter(({ key }) =>
        key.toLowerCase().includes(searchTerm)
    );

    const background = [
        '#4B3832', // Rich chocolate brown
        '#2A4D69', // Deep navy blue
        '#588157', // Forest green
        '#8A3335', // Dark red
        '#2C2D2E', // Charcoal gray
        '#3A5A40', // Moss green
        '#5D5F71', // Slate blue
        '#6A0572', // Dark violet
        '#5E3023', // Mahogany
        '#0B6E4F'  // Deep teal
    ];

    

    if (loading) {
        return (
            <div className="container" style={{
                position: 'absolute',  // Keep it absolute for positioning
                top: '40%',            // Position it 40% from the top of the page
                left: '50%',           // Horizontally center the container
                transform: 'translateX(-50%)', // Offset by 50% of its width to truly center
                display: 'flex',       // Flexbox for centering
                justifyContent: 'center', // Center content horizontally
                alignItems: 'center',  // Align content vertically
                zIndex: 1,             // Ensure it's on top of other content
                width: '100%',         // Full width of the page
                backgroundColor: 'transparent',  // Transparent background
                paddingTop: '20px',    // Optional padding from the top
            }}>
  
  <div class="typewriter">
      <div class="slide"><i></i></div>
      <div class="paper"></div>
      <div class="keyboard"></div>
  </div>
    
                {/* Keyframes for spinner rotation, text fade-in, and up effect */}
                <style>{`
                   /* From Uiverse.io by Nawsome */ 
  .typewriter {
    --blue: #5C86FF;
    --blue-dark: #275EFE;
    --key: #fff;
    --paper: #EEF0FD;
    --text: #D3D4EC;
    --tool: #FBC56C;
    --duration: 3s;
    position: relative;
    -webkit-animation: bounce05 var(--duration) linear infinite;
    animation: bounce05 var(--duration) linear infinite;
  }
  
  .typewriter .slide {
    width: 92px;
    height: 20px;
    border-radius: 3px;
    margin-left: 14px;
    transform: translateX(14px);
    background: linear-gradient(var(--blue), var(--blue-dark));
    -webkit-animation: slide05 var(--duration) ease infinite;
    animation: slide05 var(--duration) ease infinite;
  }
  
  .typewriter .slide:before, .typewriter .slide:after,
  .typewriter .slide i:before {
    content: "";
    position: absolute;
    background: var(--tool);
  }
  
  .typewriter .slide:before {
    width: 2px;
    height: 8px;
    top: 6px;
    left: 100%;
  }
  
  .typewriter .slide:after {
    left: 94px;
    top: 3px;
    height: 14px;
    width: 6px;
    border-radius: 3px;
  }
  
  .typewriter .slide i {
    display: block;
    position: absolute;
    right: 100%;
    width: 6px;
    height: 4px;
    top: 4px;
    background: var(--tool);
  }
  
  .typewriter .slide i:before {
    right: 100%;
    top: -2px;
    width: 4px;
    border-radius: 2px;
    height: 14px;
  }
  
  .typewriter .paper {
    position: absolute;
    left: 24px;
    top: -26px;
    width: 40px;
    height: 46px;
    border-radius: 5px;
    background: var(--paper);
    transform: translateY(46px);
    -webkit-animation: paper05 var(--duration) linear infinite;
    animation: paper05 var(--duration) linear infinite;
  }
  
  .typewriter .paper:before {
    content: "";
    position: absolute;
    left: 6px;
    right: 6px;
    top: 7px;
    border-radius: 2px;
    height: 4px;
    transform: scaleY(0.8);
    background: var(--text);
    box-shadow: 0 12px 0 var(--text), 0 24px 0 var(--text), 0 36px 0 var(--text);
  }
  
  .typewriter .keyboard {
    width: 120px;
    height: 56px;
    margin-top: -10px;
    z-index: 1;
    position: relative;
  }
  
  .typewriter .keyboard:before, .typewriter .keyboard:after {
    content: "";
    position: absolute;
  }
  
  .typewriter .keyboard:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 7px;
    background: linear-gradient(135deg, var(--blue), var(--blue-dark));
    transform: perspective(10px) rotateX(2deg);
    transform-origin: 50% 100%;
  }
  
  .typewriter .keyboard:after {
    left: 2px;
    top: 25px;
    width: 11px;
    height: 4px;
    border-radius: 2px;
    box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    -webkit-animation: keyboard05 var(--duration) linear infinite;
    animation: keyboard05 var(--duration) linear infinite;
  }
  
  @keyframes bounce05 {
    85%, 92%, 100% {
      transform: translateY(0);
    }
  
    89% {
      transform: translateY(-4px);
    }
  
    95% {
      transform: translateY(2px);
    }
  }
  
  @keyframes slide05 {
    5% {
      transform: translateX(14px);
    }
  
    15%, 30% {
      transform: translateX(6px);
    }
  
    40%, 55% {
      transform: translateX(0);
    }
  
    65%, 70% {
      transform: translateX(-4px);
    }
  
    80%, 89% {
      transform: translateX(-12px);
    }
  
    100% {
      transform: translateX(14px);
    }
  }
  
  @keyframes paper05 {
    5% {
      transform: translateY(46px);
    }
  
    20%, 30% {
      transform: translateY(34px);
    }
  
    40%, 55% {
      transform: translateY(22px);
    }
  
    65%, 70% {
      transform: translateY(10px);
    }
  
    80%, 85% {
      transform: translateY(0);
    }
  
    92%, 100% {
      transform: translateY(46px);
    }
  }
  
  @keyframes keyboard05 {
    5%, 12%, 21%, 30%, 39%, 48%, 57%, 66%, 75%, 84% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    9% {
      box-shadow: 15px 2px 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    18% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 2px 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    27% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 12px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    36% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 12px 0 var(--key), 60px 12px 0 var(--key), 68px 12px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    45% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 2px 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    54% {
      box-shadow: 15px 0 0 var(--key), 30px 2px 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    63% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 12px 0 var(--key);
    }
  
    72% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 2px 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  
    81% {
      box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 12px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
    }
  }
                `}</style>
            </div>
        );
    }
    

    if (error) {
        return <div className="error">Error: {error}</div>;
    }
    const categoryColors = {
        "mou-bg": "linear-gradient(45deg,#6610f2,#20c997)", // Red gradient
        "patent-bg": "linear-gradient(45deg, #54C1EB, #82E4FF)", // Blue gradient
        "research-bg": "linear-gradient(45deg, #F9D976, #F39C12)", // Yellow gradient
        "innovation-bg": "linear-gradient(45deg, #48C9B0, #A3E4D7)", // Teal gradient
    };
    return (
        <div className="m-2" style={{marginTop:'0%'}}>
            <ToastContainer />
   
            <div style={{ 
  width: "100%", 
  overflow: "hidden", 
  whiteSpace: "nowrap", 
  padding: "12px 0" 
}}>
  {/* <div 
    style={{ 
      display: "inline-block", 
      animation: "scroll 10s linear infinite", 
      fontSize: "30px", 
      color: "rgb(6, 36, 119)", 
      fontWeight: "bold", 
      cursor: "pointer"
    }}
    onClick={() => history.push("/rab#")}
    onMouseOver={(e) => e.target.style.textDecoration = "underline"}
    onMouseOut={(e) => e.target.style.textDecoration = "none"}
  >
   
     Research Advisory Board Meet-2025
    <span style={{ color: "teal", marginLeft: "5px" }}> </span>
  </div> */}

  <style>
    {`
      @keyframes scroll {
        from { transform: translateX(100%); }
        to { transform: translateX(-100%); }
      }
    `}
  </style>
</div>

            {/* Header / Demo Button Section */}
            <div className="d-flex justify-content-between align-items-center mb-4 px-3 py-3" style={{ background: 'linear-gradient(135deg, #ffffff, #f1f3f5)', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', border: '1px solid rgba(0,0,0,0.05)' }}>
                <div>
                    <h3 className="mb-1" style={{ fontWeight: '700', color: '#2A4D69', fontSize: '1.6rem', letterSpacing: '-0.5px' }}>
                        Welcome back, {username || 'Faculty'}!
                    </h3>
                    <p className="text-muted mb-0" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                        <i className="fas fa-briefcase me-1 text-secondary"></i> {designation || 'Research Contributor'} | Sona R&D Portal Dashboard
                    </p>
                </div>
                <div>
                    <button 
                        className="btn d-flex align-items-center gap-2" 
                        onClick={() => setShowDemoModal(true)}
                        style={{
                            background: 'linear-gradient(135deg, #2A4D69, #4b86b4)',
                            color: '#fff',
                            border: 'none',
                            padding: '10px 24px',
                            borderRadius: '50px',
                            fontWeight: '600',
                            boxShadow: '0 4px 15px rgba(42, 77, 105, 0.3)',
                            transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                            letterSpacing: '0.3px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.03)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(42, 77, 105, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(42, 77, 105, 0.3)';
                        }}
                    >
                        <i className="fas fa-play-circle" style={{ fontSize: '1.3rem' }}></i>
                        Watch Video Demo
                    </button>
                </div>
            </div>

    {/* Grid Layout for Counts and Charts */}
    <div className="m-2">
    {/* Cards Section */}
    <div className="row mb-5">
    {filteredEndpoints.map(({ label, setter, icon, url, category }, index) => {

        // Inline dictionary for category colors
        const categoryColors = [
            "linear-gradient(45deg, #20c997, #17a2b8)", // Red gradient
            "linear-gradient(45deg, #FF6F61, #FFB6B9)", // Blue gradient
            "linear-gradient(90deg, #4C9FFF, #A7C7E7)", // Yellow gradient
            "linear-gradient(135deg, #FFB74D, #FFEB8E)", // Teal gradient
            "linear-gradient(45deg, #EAECEE, #ABB2B9)",
            "linear-gradient(45deg, #A569BD, #D7BDE2)", // Fallback gray gradient
        ];

        // Rotate through categoryColors using the index
        const background = categoryColors[index % categoryColors.length];

        return (
            <div key={label} className="col-md-2">
               <NavLink
    to={url}
    className="card shadow-sm rounded"
    style={{
        border: "0.5px solid rgba(0, 0, 0, 0.125)",
        padding: "0.45rem",
        textDecoration: "none",
        background: background, // Sequential background
        color: "#fff", // Text color for better contrast
    }}
>
    <motion.div
        className="card-body text-center p-2 text-dark"
        whileHover={{
            rotate: [0, -2, 2, -2, 2, 0], // Angular shake effect on hover
            scale: 1,                  // Slight enlargement on hover
        }}
        transition={{
            duration: 4,        // Duration of animation
            ease: "linear",     // Linear easing
            repeat: Infinity,   // Infinite while hovering
        }}
    >
        <div className="card-icon mb-2">
            <i className={`fas ${icon} fa-2x`} aria-hidden="true"></i>
        </div>
        <h5 className="card-title text-uppercase fs-6 mb-2">
            {`${label.charAt(0).toUpperCase() + label.slice(1)}`}
        </h5>
        <p className="card-count fw-bold h4">
            <CountUp 
                start={0} 
                end={counts[setter]} 
                duration={2} 
            />
        </p>
    </motion.div>
</NavLink>
            </div>
        );
    })}
</div>


    {/* Charts Section */}
    <div className="row ">

        {/* Bar Chart */}
        <div className="col-md-4">
        <h5
                className="ps-4"
                style={{
                    fontFamily: 'MassFont, sans-serif',
                    opacity: 0.9,
                    fontWeight: 'bold',
                    color: '#343a40',
                }}
            >
               Filter by Department
            </h5>
            <div className=" p-3">
                <Homes/>
            </div>
        </div>
        <div className="col-md-8">
        <h5
                className="ms-2"
                style={{
                    fontFamily: 'MassFont, sans-serif',
                    opacity: 0.9,
                    fontWeight: 'bold',
                    color: '#343a40',
                }}
            >
               Departmentwise R & D Contribution 
            </h5>
            <div className="p-2">
                <Homebar />
            </div>
        </div>
        

    </div>
</div>

            {/* Demo Video Modal */}
            <Modal 
                show={showDemoModal} 
                onHide={() => setShowDemoModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                    <Modal.Title style={{ fontWeight: '700', color: '#2A4D69' }}>
                        <i className="fas fa-video me-2 text-primary"></i>
                        Portal Walkthrough / Demo
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '0', backgroundColor: '#000', overflow: 'hidden' }}>
                    <div className="ratio ratio-16x9">
                        <video 
                            controls 
                            autoPlay
                            style={{ width: '100%', height: '100%', display: 'block', maxHeight: '70vh' }}
                            width="800"
                        >
                            <source src="https://pub-dae1585dff4a4a27b60f0128cb70ed8f.r2.dev/R%26D%20Portal%20Demo%20Video_compressed.mp4" type="video/mp4" />
                        </video>
                    </div>
                </Modal.Body>
            </Modal>

</div>

    );
};

export default Home;
